"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeToken = exports.validateToken = exports.checkWardenHealth = void 0;
var flow_1 = __importDefault(require("lodash/flow"));
var test_1 = __importDefault(require("./functions/test"));
var validateToken_1 = __importDefault(require("./functions/validateToken"));
var exchangeToken_1 = __importDefault(require("./functions/exchangeToken"));
var envelope_1 = require("@fuze/apis-core/dist/envelope");
var injectAsyncArguments_1 = __importDefault(require("@fuze/apis-core/dist/injectAsyncArguments"));
var providers_1 = require("../providers");
var injectArguments = injectAsyncArguments_1.default(providers_1.getUrl, providers_1.getAppKey);
var wrapWardenFunction = flow_1.default(providers_1.errorInterceptor, injectArguments);
var wrapWardenFunctionUnhandled = injectArguments;
/**
 * Returns a promise that resolves to true if the health check is successful
 * and rejects otherwise
 */
var checkWardenHealth = function () { return wrapWardenFunction(test_1.default); };
exports.checkWardenHealth = checkWardenHealth;
var validateToken = function (token) {
    return flow_1.default(wrapWardenFunctionUnhandled, envelope_1.extractDataFromEnvelope)(validateToken_1.default)(token);
};
exports.validateToken = validateToken;
var exchangeToken = function (token) {
    return flow_1.default(wrapWardenFunctionUnhandled, envelope_1.extractDataFromEnvelope)(exchangeToken_1.default)(token);
};
exports.exchangeToken = exchangeToken;
